import React, { useEffect } from "react";
import { Heading } from "../../../subComponents/Heading";
import { Text } from "../../../subComponents/text";
import AOS from "aos";
import "aos/dist/aos.css";

const StorySection = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      <section className="story_section">
        <div className="innerstory_section shadow">
          <div style={{ width: "max-content", margin: "auto" }}>
            <Heading orangeheading={"Our"} title={"Story"} data-aos="zoom-in" />
          </div>
          <div className="story_container" style={{ overflowX: "hidden" }}>
            {/* story left container start from here */}
            <div className="story_left_container" data-aos="fade-right">
              <Text
                style={{
                  fontSize: "1.4rem",
                  lineHeight: "2.5rem",
                  fontWeight: "500",
                  textAlign: "justify",
                }}
                text={
                  <>
                    <strong>
                      TUBE <span style={{ color: "var(--orange)" }}>FLEX</span>{" "}
                      INDIA
                    </strong>{" "}
                    was established in 2025 and is rapidly expanding its
                    services across India, focusing on outstanding service
                    records, collaborative partnerships, innovation, and
                    corporate responsibility. This company is recognized for
                    emphasizing growth through dedication to customer
                    satisfaction and the adoption of innovative practices in the
                    extruded part (Tube, Spiral & Profile) industry
                    <p style={{ marginTop: "2rem" }}>
                      <strong>
                        TUBE{" "}
                        <span style={{ color: "var(--orange)" }}>FLEX</span>{" "}
                        INDIA
                      </strong>{" "}
                      Manufactures of Extruded & Moulding Parts & In house with
                      nylon and hose assemblies
                    </p>
                    {/* <p>Tool Room for extrusion die, Jig & Fixture manufacturing</p> */}
                  </>
                }
              />
              <br />
              <div className="manager_container">
                {/* <Text text={"Mr. Jatin Gupta"} /> */}
                <div style={{ width: "max-content" }}>
                  <Text text={"Tube Flex India"} />
                </div>
              </div>
            </div>
            {/* story left container close from here */}

            {/* story right container start from here */}
            <div className="story_right_container" data-aos="fade-left">
              <Text
               style={{fontSize:"16px"}}
                text={
                  <>
                     At TUBE FLEX INDIA, we specialize in manufacturing extruded and moulding parts, including tubes, spirals, and profiles, along with in-house production of nylon and hose assemblies. Our advanced manufacturing capabilities and skilled workforce enable us to provide customized solutions tailored to diverse industrial needs.
                     <br />
                     <br />

                     We take pride in our dedication to quality control, innovation, and corporate responsibility, ensuring that every product reflects our commitment to excellence. Based in Faridabad, Haryana, we continue to grow as a trusted name in the industry, delivering value-driven solutions to our clients.
                     <br /><br />

                     Our journey is guided by a simple philosophy — to build lasting relationships through quality products, dependable service, and continuous improvement.

                  </>
                }
              />
              <br />
              <Text
               style={{fontSize:"16px"}}
                text={`Based out of Faridabad, Haryana, Tube Flex India is committed to excellence and innovation in the interior products industry.`}
              />
              <br />
              <Text
               style={{fontSize:"16px"}}
                text={` Partner with us for exceptional quality and service in every product we deliver. Our Facilities and Presence`}
              />
              {/* <Text text={"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like)."} /> */}
              <br />
              {/* <Text text={"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout."}/> */}
            </div>
            {/* story right container close from here */}
          </div>
        </div>
      </section>
    </>
  );
};
export { StorySection };
